import { Component, Prop, h, Fragment } from '@stencil/core';
import { Price, PriceCalculation } from '../../../types/types';
import { t } from '../../../redux/utils';

@Component({
  tag: 'rtr-cart-item-total-price',
  shadow: false,
  styleUrl: 'style.sass',
})
export class RtrCartItemTotalPrice {
  @Prop() price!: Price;

  render() {
    return <Fragment>
      ({t('cart.articleTotalLabel')} <rentware-item-price price={this.price} type={PriceCalculation.Interval} />)
    </Fragment>
  }
}
